module.exports = __webpack_public_path__ + "img/wapRectangle 247@2x.2069716e.png";